import { render } from "./SingleMenu.vue?vue&type=template&id=881e602a&scoped=true"
import script from "./SingleMenu.vue?vue&type=script&lang=js"
export * from "./SingleMenu.vue?vue&type=script&lang=js"

import "./SingleMenu.vue?vue&type=style&index=0&id=881e602a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881e602a"]])

export default __exports__